export const MODEL_OPTION_ITEM_CLASS =
  "relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none hover:bg-gray-50 focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50";

export const PANEL_GAP = 10;
export const VIEWPORT_PAD = 8;
export const PANEL_FALLBACK_WIDTH = 288;
export const PANEL_BRIDGE_ITEM_OVERLAP = 2;
export const PANEL_BRIDGE_MIN_WIDTH = 14;
export const PANEL_BRIDGE_WIDTH_BUFFER = 4;
